module.exports = __webpack_public_path__ + "assets/c4527dccb95111e3b8623ca8a187c5b2.png";